/**
 * Cap on how many bundles the discovery row renders/mounts at once (UX judgment call, not
 * measured -- open to revisiting with real usage data).
 *
 * Kept in its own leaf module with no React/styled-components imports: use-bundle-product-ids.ts
 * only needs this number, and importing it from bundles-row.tsx would pull in bundle-card.tsx's
 * styled-components and renumber generated class IDs for unrelated snapshots elsewhere.
 */
export const MAX_BUNDLES_DISPLAYED = 12;
